import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import {StyleSheet} from 'aphrodite';

import ClaimNOCPage from '../ClaimNOC';

export class ClaimNOCStyleWrapperPage extends Component {
  render() {
    const {
      settings,
    } = this.props;

    const styleSheetObject = {
      // Maybe style links via settings.page.link.style.color
      header: settings.styles.header,
      footer: settings.styles.footer,
      headerLogo: settings.styles.headerLogo,
      footerLogo: settings.styles.footerLogo,
      headerLink: settings.styles.headerLink,
      headerPageLink: settings.styles.headerPageLink,
      footerRows: settings.styles.footerRows,
      footerLink: settings.styles.footerLink,
      modalReject: settings.styles.modalReject,
      modalSuccess: settings.styles.modalSuccess,
      interstitialModalReject: settings.styles.interstitialModalReject,
      interstitialModalSuccess: settings.styles.interstitialModalSuccess, // Maybe can be combined into a single button class
      loginButton: settings.styles.loginButton, // Maybe can be combined into a single button class
      isi: settings.styles.isi,
      boxedIsi: settings.styles.boxedIsi,
      topRightLink: settings.styles.topRightLink,
      topRightExpandToggle: settings.styles.topRightExpandToggle,
      fixedIsi: settings.styles.fixedIsi,
      isiShrunk: settings.styles.isiShrunk,
      isiExpanded: settings.styles.isiExpanded,
      faq: settings.styles.faq,
      searchButton: settings.styles.searchButton,
      footNote: settings.styles.footNote,
      results: settings.styles.results,
      highlightRow: settings.styles.highlightRow,
      highlightRowPara: settings.styles.highlightRowPara,
      highlightRowDisclaimer: settings.styles.highlightRowDisclaimer,
      dataTable: settings.styles.dataTable,
      searchResults: settings.styles.searchResults,
      isiContentLink: settings.styles.isiContentLink,
      isiContentBold: settings.styles.isiContentBold,
      boxedIsiSpecialRenderer: settings.styles.boxedIsiSpecialRenderer,
      initialTherapyCell: settings.styles.initialTherapyCell,
      initialTherapyColumn: settings.styles.initialTherapyColumn,
      faqPreface: settings.styles.faqPreface,
      faqLink: settings.styles.faqLink,
      footerLinkInNonLinkSection: settings.styles.footerLinkInNonLinkSection,
      modalBackdrop: settings.styles.modalBackdrop,
      initialSearchInstruction: settings.styles.initialSearchInstruction,
      loginInstruction: settings.styles.loginInstruction,
      loginContent: settings.styles.loginContent,
      tooltip: settings.styles.tooltip,
      searchPreface: settings.styles.searchPreface,
      loginBackground: settings.styles.loginBackground,
      preface: settings.styles.preface,
      bannerTabs: settings.styles.bannerTabs,
      banner: settings.styles.banner,
      clearButton: settings.styles.clearButton,
    };

    settings.styles.tableColumns.forEach((column) => {
      styleSheetObject[`tableColumn${column.property}`] = column.style;
    });

    let footerElementIndex = 0;
    settings.styles.footerLayout.forEach((rowArray) => {
      rowArray.forEach((column) => {
        styleSheetObject[`footerElement${footerElementIndex++}`] = column.style;
      });
    });

    const styleSheet = StyleSheet.create(styleSheetObject);
    return (<ClaimNOCPage styleSheet={styleSheet}/>);
  }
}

ClaimNOCStyleWrapperPage.propTypes = {
  settings: PropTypes.object.isRequired,
};

const mapStateToProps = function (state) {
  const {
    settings,
  } = state;

  return {
    settings: settings.get('settings').toJS(),
  };
};

export default connect(
  mapStateToProps,
)(withRouter(ClaimNOCStyleWrapperPage));



// WEBPACK FOOTER //
// ./src/pages/ClaimNOCStyleWrapper/index.jsx